import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";

export default {
  name: "CustomerService",
  components: {
    TableList,
    DateField
  },
  data() {
    return {
      headers: [
        //{field:'Code',          label:'Código' },
        { field: "Merchant.Name", label: "Cliente", classHeader: 'text-left', classField: 'text-left' },
        { field: "CreatedDate", label: "Data", type: "date" },
        { field: "Description", label: "Descrição", classHeader: 'text-left', classField: 'text-left' },
        { field: "CustomerServiceCategory.Name", label: "Categoria", classHeader: 'text-left', classField: 'text-left' },
        { field: "UserInternal.Name", label: "Usuário" }
      ],
      pageName: 'Atendimento ao Cliente',
      permissionIsAuthorize: 'CustomerService',
      modalTitle: "Nova Descrição",
      countFilter: 0,
      itemList: [],
      lists: {
        UsersInternal: [],
        CustomerServiceCategoriesFilter: [],
        CustomerServiceCategoriesForm: [],
        Merchants: []
      },
      filter: {
        IdMerchant: null,
        NameMerchant: null,
        IdentityMerchant: null,
        IdUserInternal: null,
        CodeCustomerServiceCategory: null,
        CreatedDateIni: null,
        CreatedDateFin: null
      },
      idField: 0,
      formField: {
        Merchant: { Id: null },
        CreatedDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        Description: null,
        CustomerServiceCategory: { Code: null },
        UserInternal: { Id: this.$getUserInternal().Id }
      },
      isSeeing: false,
      loading: false,
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFormValidation: false,
      additionalActions: [
        {authorization: 'Add', name: 'Add', label: 'Adicionar Continuação', icon:'fas fa-plus'}
      ]
    };
  },

  mounted() {
    this.loading = true;
    const promises = [
      this.ListMerchant(),
      this.ListUserInternal(),
      this.ListCustomerServiceCategory()
    ];
    Promise.all(promises).then(
      (values) => {
        this.ListCustomerService();
      }
    );
  },

  methods: {
    OpenField(item, index, eventName) {
      this.validatedFormValidation = false;
      this.ResetFormField();
      if (eventName == 'Add') {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Anotação";
        this.formField.Merchant.Id = item.Merchant.Id;
        this.formField.Merchant.Name = item.Merchant.Id + ' - ' + item.Merchant.Name;
        this.$bvModal.show("mFormField");
      } else {
        // View
        this.pOpened = index;
        this.idField = item.Id;
        this.formField.Merchant.Id = item.Merchant.Id;
        this.formField.Merchant.Name = item.Merchant.Name;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.GetCustomerService();
        this.$bvModal.show("mFormField");
      }
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListCustomerService();
    },

    ResetFilter() {
      this.filter = {
        IdMerchant: null,
        NameMerchant: null,
        IdentityMerchant: null,
        IdUserInternal: null,
        CodeCustomerServiceCategory: null,
        CreatedDateIni: null,
        CreatedDateFin: null
      };
      this.ListCustomerService();
    },

    ResetFormField() {
      this.formField = {
        Merchant: { Id: null },
        CreatedDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        Description: null,
        CustomerServiceCategory: { Code: null },
        UserInternal: { Id: this.$getUserInternal().Id }
      };
    },

    SaveField() {
      this.validatedFormValidation = true;
      this.$refs.CustomerServiceValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loading = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.AddCustomerService();
          }
        }
      });
    },

    GetParamsListCustomerService(deletePagination = false) {
      const regExp = new RegExp(/[\D]/g);
      if(this.filter.IdentityMerchant != null && regExp.test(this.filter.IdentityMerchant)){
        this.$makeToast("Removido characteres que não são digitos.", "warning", "Alterada a Busca de CNPJ");
        this.filter.IdentityMerchant = this.filter.IdentityMerchant.replace(/[\D]/g, '');
        if(this.filter.IdentityMerchant.length == 0){
          this.filter.IdentityMerchant = null;
          this.$makeToast("Com os characteres removidos não sobrou nada, CNPJ foi desconsiderado.", 
                          "warning", "CNPJ Desconsiderado");
        }
      }
      let data = {
        ...this.pagination,
        "Object.Merchant.Id": this.filter.IdMerchant,
        "Object.Merchant.Name": this.filter.NameMerchant,
        "Object.Merchant.Identity": this.filter.IdentityMerchant,
        "Object.UserInternal.Id": this.filter.IdUserInternal,
        "Object.CustomerServiceCategory.Code": this.filter.CodeCustomerServiceCategory,
        "InitialDate": this.filter.CreatedDateIni,
        "EndDate": this.filter.CreatedDateFin
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    AddCustomerService() {
      delete this.formField.CreatedDate;
      delete this.formField.Merchant.Name;
      this.$store
        .dispatch("AddMerchantNote", this.formField)
        .then(() => {
          this.$makeToast("O campo foi cadastrado com sucesso.", "success", "Campo cadastrado");
          this.$bvModal.hide("mFormField");
          setTimeout(() => {
            this.ListCustomerService();
          }, 100);
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao criar campo", error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    GetCustomerService() {
      if (this.idField != 0) {
        this.loading = true;
        this.$store.dispatch("GetMerchantNote", { id: this.idField })
          .then(response => {
            this.formField = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    ListCustomerService() {
      this.loading = true;
      this.countFilter = 0;
      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.IdUserInternal)) this.countFilter++;
      if (hasValue(this.filter.CodeCustomerServiceCategory)) this.countFilter++;
      if (hasValue(this.filter.CreatedDate)) this.countFilter++;
      const params = this.GetParamsListCustomerService();
      this.$store.dispatch("ListMerchantNote", { params:params })
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        })
        .finally(() => (this.loading = false));
    },

    GetReport() {
      this.loading = true;
      const params = this.GetParamsListCustomerService(true);
      this.$store.dispatch("ReportMerchantNote", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loading = false;
          }, 1200);
        });
    },

    ListUserInternal() {
      return this.$store.dispatch("ListUserInternal", { params: {} })
        .then((response) => {
          this.lists.UsersInternal = response.Objects;
          if(this.lists.UsersInternal.lenght > 1){
            this.lists.UsersInternal.sort((a, b) => a.Name.localeCompare(b.Name));
          }
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página", "danger", "Erro ao obter lista de usuários", error);
        });
    },

    ListCustomerServiceCategory() {
      return this.$store.dispatch("ListCustomerServiceCategory", { ListActiveAndExcluded: true })
        .then(response => {
          const CSC = response.Objects;
          if(CSC.length > 1){
            //CSC.sort((a, b) => a.Code.localeCompare(b.Code));
            this.lists.CustomerServiceCategoriesFilter = CSC;
            this.lists.CustomerServiceCategoriesForm = CSC.filter((category) => !category.IsExcluded );
          }
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        });
    },

    ListMerchant() {
      let params = {
        "Object.IsRemoved": false,
        "Object.IsTest": false,
        "Object.IsMerchantRoot": true,
      };
      return this.$store
        .dispatch("ListMerchant", { params: params })
        .then((response) => {
          this.lists.Merchants = response.Objects;
          if(this.lists.Merchants.lenght > 1){
            this.lists.Merchants.sort((a, b) => a.Name.localeCompare(b.Name));
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os clientes", error);
        });
    },

    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/CustomerService/CustomerService.js